import { GridRowId } from '@mui/x-data-grid';
import GoalDeleteButton from './GoalDeleteButton';
import GoalEditButton from './GoalEditButton';

export type GoalActionProps = {
  rowId: GridRowId;
  planIndex: number;
};

const GoalAction = ({ rowId, planIndex }: GoalActionProps) => {
  return (
    <>
      <GoalEditButton rowId={rowId} planIndex={planIndex} />
      <GoalDeleteButton rowId={rowId} planIndex={planIndex} />
    </>
  );
};

export default GoalAction;
